import {TextLinkWidget} from '@tableau/widgets';
import React from 'react';

import {FormikCheckbox} from '~commonInfra/components/FormikCheckbox';
import {ExtensionsSettingsSubspaceState} from '~src/app/spaces/SharedSettingsSpace/ExtensionsSettingsSubspaceShared';
import {SettingsSection} from '~src/settings/components/common/SettingsSection';
import {useFormikContext} from '~src/settings/FormikWrapperForStubbing';
import {PrepExtensionsSettingsSubFormikProps} from '~src/settings/general-settings/components/extensions-settings/ExtensionsSettingsCoordinator';
import {componentRegistryEntry} from '~src/settings/general-settings/components/SettingsComponentRegistryFunctions';
import {learnMoreStyle} from '~src/settings/styles/CommonStyles';
import {ISiteAdminSettings} from '~src/settings/types/ISiteSettingsForSiteAdmin';
import {Sites} from '~src/ts/siteManagement/services/resources/Sites';

import { Messages } from '../../../../../codegen/Localize';

const PREP_EINSTEIN_ENABLED_FIELD = 'settings.siteSettingsForSiteAdmin.siteAdminSettings.einsteinInFlowEnabled';

export const PREP_EXTENSIONS_SITE_EINSTEIN_CHECKBOX = 'prep-extensions-enable-site-einstein';

const prepEinsteinUrl = 'https://help.tableau.com?page=prep_predictions';

function createDescription(): JSX.Element {
  return (<div>
    {Messages.prepExtensionsSiteDescription()}
    <TextLinkWidget testId={'prep-extensions-link'}
                    target={'_blank'}
                    className={learnMoreStyle}
                    href={prepEinsteinUrl}>
      {Messages.learnMore()}
    </TextLinkWidget>
  </div>);
}


export function PrepExtensionsSiteSection(_props: PrepExtensionsSettingsSubFormikProps) {
  const formik = useFormikContext<PrepExtensionsSettingsSubFormikProps>();

  return (
      <div>
        <SettingsSection title={Messages.prepExtensions()}
                         description={createDescription()}>
        <FormikCheckbox
                          checked={formik.getFieldProps(PREP_EINSTEIN_ENABLED_FIELD).checked}
                          label={Messages.prepExtensionsEinsteinSiteLabel()}
                          name={PREP_EINSTEIN_ENABLED_FIELD}
                          testId={PREP_EXTENSIONS_SITE_EINSTEIN_CHECKBOX}/>
        </SettingsSection>
    </div>);
}

export const PrepExtensionsSiteSectionSpecs = componentRegistryEntry({
  name: 'PrepExtensionsSiteSection',
  component: PrepExtensionsSiteSection,
  onSubmit: async (settings: ExtensionsSettingsSubspaceState) => {
    const siteAdminSettings = settings.siteSettingsForSiteAdmin.siteAdminSettings as ISiteAdminSettings;
    await Promise.all([Sites.instance.updateSiteSettingsForSiteAdmin((settings.siteSettingsForSiteAdmin as any).id || settings.siteSettingsForSiteAdmin.siteId, siteAdminSettings)]);
  },
});
